export default __webpack_public_path__ + "static/media/winddirection.83fda8df.svg";